module.exports = __webpack_public_path__ + "static/img/PARIS_PAINT.f5ddf56.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/PARIS_PAINT.jpg
// module id = iAcj
// module chunks = 0